// extracted by mini-css-extract-plugin
export default {"actionButton":"ImportantMemberOfMonth_actionButton__wuCjf","customTable":"ImportantMemberOfMonth_customTable__51Ozz","statsAccordion":"ImportantMemberOfMonth_statsAccordion__i48rY"};